// extracted by mini-css-extract-plugin
export default {"link":"IconPanelLink_link__fBk2R"};